import { render } from "./DynamicHtmlH6.vue?vue&type=template&id=0a927450&ts=true"
import script from "./DynamicHtmlH6.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlH6.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlH6.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a927450"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a927450', __exports__)) {
    api.reload('0a927450', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlH6.vue?vue&type=template&id=0a927450&ts=true", () => {
    api.rerender('0a927450', render)
  })

}


export default __exports__